module.exports = __webpack_public_path__ + "static/media/lunch6.21f83e32.png";